import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FeeService } from '../../../services/FeeService';
import { GL_MasterService } from '../../../services/Acc_GL_Master.service';
import { MatSnackBar } from '@angular/material';
@Component({
  selector: 'app-fee-add',
  templateUrl: './fee-add.component.html',
  styleUrls: ['./fee-add.component.css']
})
export class FeeAddComponent implements OnInit {
  constructor(private FeeService: FeeService, public snackBar: MatSnackBar, private GL_MasterService: GL_MasterService) { }
  years = new Array();
  semester = new Array();
  departments: any = {};
  ngOnInit() {
    Array.from({length: 30}, (x, i) => this.years.push(i + 1380));
    Array.from({ length: 14 }, (x, i) => this.semester.push(i + 1));
    this.GL_MasterService.getDepartments().subscribe(a => { this.departments = a; });
  }

  onSubmit(f: NgForm) {
    if (f.valid) {
      console.log("Form Validity: " + f.valid);
      this.FeeService.addFee(f.value).subscribe(r => {        
        if (r != 'Error') {
          this.snackBar.open("فیس اضافه شد", null, { duration: 5000 });
        } else {
          this.snackBar.open("خطا در ثبت", null, { duration: 5000 });
        }
      });
    } else {
      this.snackBar.open("ورودی درست نیست", null, { duration: 5000 });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/fee/fee-add/fee-add.component.ts